import { render } from "./TableDataCell.vue?vue&type=template&id=07c53b4f&ts=true"
import script from "./TableDataCell.vue?vue&type=script&lang=ts"
export * from "./TableDataCell.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__